module.exports = "/wwwroot/img/rss_feed_block.png?ver=8459e11a";